import React from "react";
import styled from "styled-components";

const TypingIndicator = () => (
  <Wrapper>
    <Dot $delay="0s" />
    <Dot $delay="0.2s" />
    <Dot $delay="0.4s" />
  </Wrapper>
);

export default TypingIndicator;

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0.2rem 0;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #666;
  animation: bounce 1s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay || "0s"};

  @keyframes bounce {
    0%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-6px);
    }
  }
`;
